import { SearchUserEnriched } from 'lib-search-types';
import { WorkingMediaType } from 'lib-shared-legacy-types';

import { mediaToChannels } from 'utils/channels';

// Map working_media_types values (from API) to mediaToChannels keys
const workingMediaToMediaKey: Record<string, keyof typeof mediaToChannels> = {
  speak: 'speak',
  email: 'email',
  message: 'messaging',
  interactive_chat: 'interactivechat',
};

export const getWorkingChannels = (
  member: SearchUserEnriched,
): WorkingMediaType[] => {
  if (!member.working_media_types) {
    return [];
  }

  return member.working_media_types.flatMap((mediaType) => {
    const mediaKey = workingMediaToMediaKey[mediaType];
    if (!mediaKey) {
      return [];
    }
    const channels = mediaToChannels[mediaKey];
    return channels.map((channel) => ({
      channel,
      working: true,
    }));
  });
};
